import { useFeatureFlag } from '_hooks/useFeatureFlag'
import { FeatureFlagKeys } from '@hapana/shared/constants/feature-flag.constants'

/**
 * Whether the data Migration / import surface is available to the current user.
 *
 * Migration is a Hapana-operated onboarding tool that lives inside Core (the customer staff
 * app). Visibility is driven by the `import-utility` PostHog flag, which product targets to
 * internal Hapana staff (person property email_domain = hapana.com) and can switch off without
 * a deploy. Fails closed when the flag is unset, and is the single source of truth for the flag
 * key + default across the Migration tile, route guard, and wizard pages.
 *
 * This is a client-side convenience for showing/guarding UI, not a security boundary.
 */
export const useIsMigrationEnabled = (): { isEnabled: boolean; isLoading: boolean } => {
  const { value, isLoading } = useFeatureFlag(FeatureFlagKeys.ImportUtility, {
    defaultValue: false,
  })

  // Fail closed: only an explicit boolean `true` enables the surface. A multivariate
  // string (e.g. 'control') or a number must not count as enabled for an internal-only gate.
  return { isEnabled: value === true, isLoading }
}
